/*
 * @Author: pengyong
 * @Date: 2020-11-09 15:56:14
 * @LastEditors: pengyong
 * @LastEditTime: 2020-12-03 21:58:27
 * @Description:
 * @FilePath: /exhibit/src/lang/index.js
 */
import Vue from "vue";
import VueI18n from "vue-i18n";
import elementEnLocale from "element-ui/lib/locale/lang/en";
import elementZhLocale from "element-ui/lib/locale/lang/zh-CN";
import enLocale from "./en";
import zhLocale from "./zh";
import store from '../store'

Vue.use(VueI18n);

const messages = {
    en: {
        ...enLocale,
        ...elementEnLocale
    },
    zh: {
        ...zhLocale,
        ...elementZhLocale
    }
};
const defaultLanguage = localStorage.getItem("language") || "zh";
const i18n = new VueI18n({
    locale: defaultLanguage, // set locale
    messages // set locale messages
});
// 切换语音
function changeLanuage(language) {
    i18n.locale = language;
    localStorage.setItem("language", language);
    store.commit('setLanguage',language)
}

export { i18n, changeLanuage };



// WEBPACK FOOTER //
// ./src/lang/index.js